import React, { useCallback, useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { EmptyArray } from 'lib/array/arrayUtils'
import { isRoomsInvalid } from 'lib/search/searchUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import TextButton from 'components/Luxkit/Button/TextButton'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import OfferPageStickyFooter from '../../OfferPageStickyFooter'

const StyledOfferPageStickyFooter = styled(OfferPageStickyFooter)`
  padding: ${rem(12)} ${rem(20)} ${rem(20)} ${rem(20)};
`
interface Props {
  offer: App.Offer;
  rooms?: Array<App.RoomOccupants>;
  checkInDate?: string;
}

function BedbankOfferPageStickyFooterMobile(props: Props) {
  const {
    rooms = EmptyArray,
    checkInDate,
    offer,
  } = props

  const offerPageDispatch = useOfferPageDispatch()

  const invalidRoomSelection = !rooms || isRoomsInvalid(rooms)
  const canViewOptions = !!checkInDate && !invalidRoomSelection
  const ctaLabel = useMemo(() => {
    if (canViewOptions) {
      if (rooms.length > 1) {
        return `View ${pluralizeToString('room', rooms.length)}`
      } else {
        return 'View rooms'
      }
    }
    return 'Check availability'
  }, [canViewOptions, rooms])

  const onClickAvailability = useCallback(() => {
    if (invalidRoomSelection) {
      return offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'capacity' })
    }

    if (!checkInDate) {
      return offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'checkin' })
    }

    // Reset previous room selected
    offerPageDispatch({ type: OfferPageActions.setRoomType, room: undefined })
    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'roomSelection' })
  }, [checkInDate, invalidRoomSelection, offerPageDispatch])

  return (
    <StyledOfferPageStickyFooter
      visible
      callToActionDisabled
      offer={offer}
    >
      <SoftOfferPageWalledGarden>
        <TextButton fit="full-width" size="large" kind="primary" onClick={onClickAvailability}>
          {ctaLabel}
        </TextButton>
      </SoftOfferPageWalledGarden>
    </StyledOfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
  rooms: state.rooms,
  checkInDate: state.checkInDate,
}), BedbankOfferPageStickyFooterMobile)
